import { React, useState,useEffect } from 'react';
import { Row, Col,Container } from 'react-bootstrap';
import { Link, Outlet } from "react-router-dom";

import Cart from './Cart'; // کامپوننت سبد خرید

import logo from '../img/logo.svg';
import LogoFooter from '../img/logo-footer.png';
import Whatsapp from '../img/whatsapp.png';
import HelpWhatsapp from '../img/help-whatsapp.png'
import Instagram from '../img/Instagram.png';
import email from '../img/email.png';
import { useCart } from './CartContext';
import UseMediaQuery from "./UseMediaQuery";

import shopping_cart from '../img/shopping-cart.svg';
import search from '../img/search.svg';
import menuIcon from '../img/menu-hamburger.svg';
import Ssearch from './Search';
import Menu from './Menu';
import Api from "./api";
import NumberFormatter from "./NumberFormatter";


function Layout() {
    const [OnlineGoldPrice, setOnlineGoldPrice] = useState(0);
    const fetchGoldPrice = async () => {
        try {
            const response = await Api("goldprice");
            if(response && response.success==true){
               
                setOnlineGoldPrice(response.psdata.gold_price); 
                //localStorage.setItem("goldprice", response.psdata.goldprice); 
            }
        } catch (error) {
            console.error("Error fetching price data:", error);
        }
    }

    useEffect(() => {
        fetchGoldPrice();
    }, []);

    const isMobile = UseMediaQuery("(max-width: 768px)");
    const [isSearchOpen,setIsSearchOpen] = useState(false);
    const { isCartOpen,setIsCartOpen, toggleCart } = useCart();
    const [isMenuOpen,setIsMenuOpen] = useState(false);

    const toggleSearch = () => {
        setIsCartOpen(false);
        setIsMenuOpen(false);
        setIsSearchOpen(!isSearchOpen);
        
    };
    const toggleMenu =() =>{
        setIsCartOpen(false);
         setIsSearchOpen(false);
        setIsMenuOpen(!isMenuOpen);
    }
    return (
        <div>
            {/* Header */}
            {/*<div className='header-space'></div>*/}
            <div className='header-content d-flex justify-content-center align-items-center'>
                <Row className='d-flex justify-content-center w-100'>
                    <Col className='d-flex'>
                        {/* دکمه باز کردن سبد خرید */}
                        <div className="hidden-sm box d-flex justify-content-center align-items-center ms-lg-0 ms-3" onClick={toggleMenu}>
                            <img className="hidden-sm" src={menuIcon} alt="menu" />
                        </div>
                        <div className="box d-flex justify-content-center align-items-center ms-lg-5 ms-3" onClick={toggleCart}>
                            <img src={shopping_cart} alt="Shopping Cart" />
                        </div>
                        <div className="box d-flex justify-content-center align-items-center ms-lg-5" onClick={toggleSearch}>
                            <img src={search} alt="Search" />
                        </div>
                        
                    </Col>
                    <Col className='logo'>
                        <Link to="/"> 
                            <img src={logo}></img>
                        </Link>
                    </Col>
                    <Col className='d-flex justify-content-center align-items-end flex-column'>
                        <label>قیمت لحظه‌ای طلا</label>
                        <label><NumberFormatter className="ms-2" amount={OnlineGoldPrice}  locale ='en-us'/> ریال</label>
                    </Col>
                </Row>
            </div>
          
            <div className='menu d-flex align-items-center'>
                  <Container>
                <div className='d-flex justify-content-between align-items-center'>
                    <div>
                        <Link to="/10-گردنبند">
                            <label>گردنبند</label>
                        </Link>
                    </div>
                   
                    <div>
                        <Link to="/17-دستبند">
                            <label>دستبند</label>
                        </Link>
                    </div>
                     <div>
                        <Link to="/11-گوشواره">
                            <label>گوشواره</label>
                        </Link>
                    </div>
                    <div>
                        <Link to="/15-انگشتر">
                            <label>انگشتر</label>
                        </Link>
                    </div>
                    <div>
                        <Link to="/21-آویز">
                            <label>آویز</label>
                        </Link>
                    </div>
                    <div>
                        <Link to="/14-پابند">
                            <label>پابند</label>
                        </Link>
                    </div>
                      <div>
                        <Link to="/22-مردانه">
                            <label>مردانه</label>
                        </Link>
                    </div>
                    <div>
                        <Link to="/115-کودک">
                            <label>کودک</label>
                        </Link>
                    </div>
                       <div>
                        <Link to="/101-قفل">
                            <label>قفل</label>
                        </Link>
                    </div>
                     <div>
                        <Link to="/159-برندها">
                            <label>برندها</label>
                        </Link>
                    </div>
                </div>
                </Container>
            </div>
            
            {/* کامپوننت سبد خرید */}
            <Cart />
            {/* کامپوننت سرچ */}
            <Ssearch isOpen={isSearchOpen} toggleSearch={toggleSearch} />
            <Menu isOpen={isMenuOpen} toggleMenu={toggleMenu}  />

            <Outlet />
         
            {/* Footer */}
            <div className='footer'>
                <div className='container p-5 pb-2'>
                    <div className='align-middle d-flex mx-auto footer-content justify-content-between row '>
                        <div className='text-center hidden-sm' style={isMobile?{paddingBottom:'30px'}:{paddingBottom:'60px'}}>
                            <img className="" src={LogoFooter} style={isMobile?{maxWidth:'77px'}:{}}></img>
                        </div>
                        <div className='d-flex flex-column col-md-5 col-sm-12'>
                            <h3>پشتیبانی</h3>
                            <Link to="/contact-us">تماس با ما</Link>
                            <Link to="/employmentform">فرم استخدام</Link>
                            <Link to="https://tracking.post.ir">رهگیری مرسولات پستی</Link>
                            <Link to="/content/3-قوانین-و-مقررات">قوانین و مقررات</Link>
                            <Link to="/content/7-سوالات-متداول">سوالات متدوال</Link>
                            <Link to="/contact">ثبت شکایات</Link>
                        </div>
                        <div className='d-flex row col-md-7 col-sm-12 mt-md-40'>
                            <div className='d-flex flex-column col-md-6 col-sm-12'>
                                <h3>حساب کاربری</h3>
                                <a 
                                    target="_blank"
                                    href={global.config.domain_url+"/identity"}
                                >اطلاعات شخصی من</a>
                                <a 
                                    target="_blank"
                                    href={global.config.domain_url+"/order-history"}
                                >سفارشات من</a>
                            </div>
                            <div className='d-flex flex-column col-md-6 col-sm-12 mt-md-40 mb-4'>
                                <div className='text-start pb-5 hidden-xs'>
                                    <img className="" src={LogoFooter}></img>
                                </div>
                                <div className='d-flex' style={isMobile?{justifyContent:'space-around'}:{justifyContent:'space-between'}}>
                                    <Link className='opacity-100'><img src={Instagram} style={isMobile?{maxWidth:'20px'}:{}}></img></Link>
                                    <Link className='opacity-100'><img src={Whatsapp} style={isMobile?{maxWidth:'20px'}:{}}></img></Link>
                                    <Link className='opacity-100'><img src={email} style={isMobile?{maxWidth:'20px'}:{}}></img></Link>
                                   
                                </div>
                            </div>
                            {!isMobile && (
                            <div className='d-flex mt-4 justify-content-between gap-4 col-md-12 col-sm-12'>
                                <div className="col-3 text-center">
                                    <a
                                        className='opacity-100'
                                        referrerPolicy="origin" 
                                        target="_blank"
                                        href="https://trustseal.enamad.ir/?id=103174&amp;Code=6NkHh0u8w6BlKLelxK4V"
                                    >
                                        <img
                                        referrerPolicy="origin"
                                        src="https://trustseal.enamad.ir/logo.aspx?id=103174&amp;Code=6NkHh0u8w6BlKLelxK4V"
                                        alt="نماد اعتماد"
                                        style={{ cursor: "pointer" }} 
                                        width="137" height="135"
                                        />
                                    </a>
                                </div>
                                <div className="col-3 text-center">
                                    <a 
                                        className='opacity-100'
                                        referrerPolicy="origin" 
                                        target="_blank" 
                                        href="https://ecunion.ir/verify/kimiagoldgallery.com?token=205392160f40b895a461" rel="nofollow">
                                            <img src="https://www.kimiagoldgallery.com/img/cms/logo 2 copy.png"  />
                                    </a>
                                </div>
                                <div className="col-3 text-center">
                                    <a 
                                        className='opacity-100'
                                        href="https://www.kimiagoldgallery.com/img/cms/IMG_7367.jpg" target="_blank"
                                    >
                                        <img src="https://www.kimiagoldgallery.com/img/cms/NEW INSO LOGO-300 Dpi copy.png" width="137" height="135" alt="دارای استاندارد" />
                                    </a>
                                </div>
                            </div>)}
                        </div>
                    </div>
                </div>
                {isMobile && (
                        <div className='enamad d-flex mt-4 justify-content-between gap-4 col-md-12 col-sm-12 pb-5'>
                            <div className="col-3 text-center">
                                <a
                                    rel="preconnect"
                                    referrerPolicy="origin" 
                                    target="_blank"
                                    href="https://trustseal.enamad.ir/?id=103174&amp;Code=6NkHh0u8w6BlKLelxK4V"
                                >
                                    <img
                                    rel="preconnect"
                                    referrerPolicy="origin"
                                    src="https://trustseal.enamad.ir/logo.aspx?id=103174&amp;Code=6NkHh0u8w6BlKLelxK4V"
                                    alt="نماد اعتماد"
                                    style={{ cursor: "pointer" }} // استفاده از JSX برای استایل
                                    width="137" height="135"
                                    />
                                </a>
                            </div>
                            <div className="col-3 text-center">
                                <a 
                                    referrerPolicy="origin" 
                                    target="_blank" 
                                    href="https://ecunion.ir/verify/kimiagoldgallery.com?token=205392160f40b895a461" 
                                    rel="nofollow">
                                        <img src="https://www.kimiagoldgallery.com/img/cms/logo 2 copy.png"  />
                                </a>
                            </div>
                            <div className="col-3 text-center">
                                <a 
                                    href="https://www.kimiagoldgallery.com/img/cms/IMG_7367.jpg" target="_blank"
                                >
                                    <img src="https://www.kimiagoldgallery.com/img/cms/NEW INSO LOGO-300 Dpi copy.png" alt="دارای استاندارد" />
                                </a>
                            </div>
                        </div>
                    )}
                    <div className='whatsapp'>
                        <a href="https://api.whatsapp.com/send?phone=989109009505"><img src={HelpWhatsapp} /></a>                        
                    </div>
                </div>
        </div>
    );
}
export default Layout;